import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const OfferCards: React.FC = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const [ref, isVisible] = useScrollAnimation(0.15);

  const prefix = language === 'fr' ? '' : `/${language}`;

  return (
    <section
      id="offers"
      className={`offers-section fade-in ${isVisible ? 'visible' : ''}`}
      ref={ref}
    >
      <div className="container">
        <h2 className="section-title">{t.offerCards.title}</h2>
        <p className="offers-intro">{t.offerCards.description}</p>
        <div className="offer-cards-grid">
          {t.offerPages.map((offer, index) => (
            <Link
              key={offer.id}
              to={`${prefix}/offers/${offer.slug}`}
              className="offer-card"
            >
              <div className="offer-card-visual">
                <img
                  src={`${process.env.PUBLIC_URL || ''}${offer.cardImage}`}
                  alt={offer.cardImageAlt}
                  className="offer-card-image"
                  loading="lazy"
                />
                <div className="offer-card-image-overlay" aria-hidden />
                <span className="offer-card-index">{index + 1}</span>
              </div>
              <div className="offer-card-body">
                <h3 className="offer-card-title">{offer.title}</h3>
                <p className="offer-card-subtitle">{offer.subtitle}</p>
                <p className="offer-card-need">{offer.cardClientNeed}</p>
                <p className="offer-card-teaser">{offer.cardTeaser}</p>
                <span className="offer-card-link">
                  <span className="offer-card-link-text">{t.offerCards.learnMore}</span>
                  <span className="offer-card-link-arrow" aria-hidden>
                    &rarr;
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OfferCards;
